import React from 'react';
import { SelectedPressReleasePage } from '../../components/SelectedPressReleasePage';
import { PressRelease } from '../../../types/types';

const App = (props: { selectedPressRelease: PressRelease }) => (
  <SelectedPressReleasePage selectedPressRelease={props.selectedPressRelease} />
);

export default App;
